import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState, useCallback, createContext } from 'react';
import { setFlagOverride, getFlagOverrides, resetFlagOverride, resetFlagOverrides } from './utils';
export var OverridesContext = createContext(null);
export var OverridesProvider = function (props) {
    var _a = useState(getFlagOverrides()), overrides = _a[0], setOverrides = _a[1];
    var setOverride = useCallback(function (key, value) {
        setFlagOverride(key, value);
        setOverrides(getFlagOverrides());
    }, []);
    var resetOverride = useCallback(function (flagName) {
        resetFlagOverride(flagName);
        setOverrides(getFlagOverrides());
    }, []);
    var resetOverrides = useCallback(function () {
        resetFlagOverrides();
        setOverrides(getFlagOverrides());
    }, []);
    var contextValue = useMemo(function () {
        return {
            overrides: overrides,
            setOverride: setOverride,
            resetOverride: resetOverride,
            resetOverrides: resetOverrides,
        };
    }, [overrides, setOverride]);
    return _jsx(OverridesContext.Provider, { value: contextValue, children: props.children });
};
